import { Network } from "../../.."
import store from "../../../../store"
import { PLAN_TYPE, STATUS_IDS } from "../../../constants"
import { formatDate, getCurrency } from "../../../formating"

export default class InsuranceApproval {
  constructor(attributes) {
    Object.assign(this, attributes)
  }

  static async getAll({ user, params: { paramsString } }) {
    try {
      const {
        data: { data: insuranceReviewData }
      } = await Network.AxiosWrapperV2.get({
        url: `insurance/review?${paramsString}`
      })

      const usersMap = new Map()
      const expenseApprovalMap = new Map()

      insuranceReviewData.forEach((expense, index) => {
        usersMap.set(expense.user?.id, expense.user)
        expenseApprovalMap.set(
          index,
          new InsuranceApproval({
            ...expense,
            user: new Network.API.Profile.User(expense.user),
            index
          })
        )
      })
      return expenseApprovalMap
    } catch (err) {
      console.error(err)
    }
  }

  static async getOne({ user, params: { link, userId } }) {
    try {
      const [
        {
          // @ts-ignore
          value: { data: insuranceReviewData }
        }
      ] = await Promise.allSettled([
        Network.AxiosWrapper({
          target: link.url,
          method: link.method,
          token: user.token,
          options: {
            disablePrefix: true
          }
        })
      ])

      return new InsuranceApproval({
        ...insuranceReviewData,
        expenseDetails: insuranceReviewData,
        user: new Network.API.Profile.User(insuranceReviewData.user)
      })
    } catch (err) {
      console.error(err)
    }
  }

  static async updateOne({ user, params: { link, msg }, payload }) {
    try {
      const { data: expenseReviewData } = await Network.AxiosWrapper({
        target: link.url,
        method: link.method,
        token: user.token,
        payload,
        options: {
          disablePrefix: true
        }
      })

      store.setNotification("notification", true, { msg })

      return new InsuranceApproval({
        ...expenseReviewData,
        expenseDetails: expenseReviewData
      })
    } catch (err) {
      console.error(err)
    }
  }

  get coverageFormatted() {
    return this.coverage?.self
      ? (() => {
          const { self, spouse, children } = this?.coverage
          let ret = ""
          if (self) ret += "Self"
          if (spouse) ret += ", Spouse"
          if (children) ret += ", Children"
          return ret
        })()
      : "Not Available"
  }
}
